function epicAccountBrands () {
  Shopify.theme.jsEpicAccountBrands = {
    init: function init() {
      this.scrollToLetter();
      this.openPopup();
      this.closePopup();
      this.searchBrands();
      this.removeBrandInit();
      this.addBrand();
    },
    closePopup: function closePopup() {
      const closeButtons = document.querySelectorAll('.js-brands-popup-close');
      const popup = document.querySelector('.js-brands-popup');
      closeButtons.forEach(button => {
        button.addEventListener('click', () => {
          popup.classList.add('hidden');
        });
      });
    },
    openPopup: function openPopup() {
      const openButtons = document.querySelectorAll('.js-open-brands-popup');
      const popup = document.querySelector('.js-brands-popup');
      openButtons.forEach(button => {
        button.addEventListener('click', () => {
          popup.classList.remove('hidden');
        });
      });
    },
    scrollToLetter: function scrollToLetter() {
      const navigationLetters = document.querySelectorAll('.brands-navidation-letter');
      const brandHeadings = document.querySelectorAll('.brand-group-heading');
      const popupContainer = document.querySelector('.brands-list'); // Adjust to your popup container's class

      navigationLetters.forEach(letter => {
        letter.addEventListener('click', () => {
          const targetLetter = letter.textContent.trim(); // Get the letter text

          let targetHeading;

          if (targetLetter === '#') {
            targetHeading = Array.from(brandHeadings).find(heading => heading.textContent.trim() === '#');
          } else {
            targetHeading = Array.from(brandHeadings).find(heading => heading.textContent.trim() === targetLetter);
          }

          if (targetHeading && popupContainer) {
            const targetPosition = targetHeading.offsetTop - popupContainer.offsetTop - 10; // Adjust for 10px offset

            popupContainer.scrollTo({
              top: targetPosition,
              behavior: 'smooth'
            });
          }
        });
      });
    },
    sanitizeString: function sanitizeString(str) {
      return str.replace(/[^\w\s]/g, '').toLowerCase();
    },
    isLetter: function isLetter(char) {
      return /^[a-zA-Z]$/.test(char);
    },
    searchBrands: function searchBrands() {
      const self = this;
      const searchInput = document.querySelector('.js-search-by-brands');
      const brandsListItems = [...document.querySelectorAll('.brands-list-item')];
      const brandGroups = [...document.querySelectorAll('.brand-group-heading')];
      const brandNavigationLetters = [...document.querySelectorAll('.brands-navidation-letter')];
      const noResultsMessage = document.querySelector('.no-results');
      if (!searchInput) return false;
      searchInput.addEventListener('input', () => {
        const searchQuery = self.sanitizeString(searchInput.value);
        let lettersVisible = {};
        let visibleBrandsCount = 0;

        if (searchQuery === '') {
          brandsListItems.forEach(item => {
            item.classList.remove('hidden');
          });
          brandNavigationLetters.forEach(letter => {
            letter.classList.remove('hidden');
          });
          brandGroups.forEach(group => {
            group.classList.remove('hidden');
          });

          if (noResultsMessage) {
            noResultsMessage.classList.add('hidden');
          }

          return;
        }

        brandsListItems.forEach(item => {
          const brandName = item.querySelector('.brands-name').textContent;
          const sanitizedBrandName = self.sanitizeString(brandName);
          const brandLetter = brandName.charAt(0).toUpperCase();

          if (sanitizedBrandName.includes(searchQuery)) {
            item.classList.remove('hidden');

            if (self.isLetter(brandLetter)) {
              lettersVisible[brandLetter] = true;
            } else {
              lettersVisible['#'] = true;
            }

            visibleBrandsCount++;
          } else {
            item.classList.add('hidden');
          }
        });

        if (noResultsMessage) {
          if (visibleBrandsCount === 0) {
            noResultsMessage.classList.remove('hidden');
          } else {
            noResultsMessage.classList.add('hidden');
          }
        }

        brandNavigationLetters.forEach(letter => {
          const letterText = letter.textContent.trim();

          if (!lettersVisible[letterText]) {
            letter.classList.add('hidden');
          } else {
            letter.classList.remove('hidden');
          }
        });
        brandGroups.forEach(group => {
          const groupLetter = group.textContent.trim();

          if (!lettersVisible[groupLetter]) {
            group.classList.add('hidden');
          } else {
            group.classList.remove('hidden');
          }
        });
      });
    },
    addBrand: function addBrand() {
      const addBrandButtons = document.querySelectorAll('.js-add-brand');
      addBrandButtons.forEach(addBrandButton => {
        const brandItem = addBrandButton.closest('.js-brands-item');
        if (!brandItem) return false;
        const brandId = brandItem.getAttribute('data-brand-id');
        const customerId = brandItem.getAttribute('data-customer-id');
        const brandName = brandItem.getAttribute('data-brand-name');
        const brandImageSrc = brandItem.getAttribute('data-brand-image-src');
        const brandCollectionUrl = brandItem.getAttribute('data-brand-collection-url');
        if (!brandId || !customerId || !brandName) return false;
        let url;

        if (Orchestra && Orchestra.epic_favorite_brands_update) {
          url = Orchestra.epic_favorite_brands_update;
        } else {
          return false;
        }

        const self = this;
        addBrandButton.addEventListener('click', e => {
          fetch(url, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              brand_id: brandId,
              customer_id: customerId,
              action: 'add'
            })
          }).then(response => response.json()).then(json => {
            if (json.success != true) return false;
            const removeBtn = brandItem.querySelector('.js-remove-brand');
            const addBtn = brandItem.querySelector('.js-add-brand');
            if (removeBtn) removeBtn.classList.remove('hidden');
            if (addBtn) addBtn.classList.add('hidden');
            const followingBrandsContainer = document.querySelector('.following-brand-following-brands');
            const followingBrandsContainerSlider = document.querySelector('.js-follow-brands-container .slider-gallery');

            if (followingBrandsContainer) {
              const newBrandElement = self.createBrandElement(customerId, brandId, brandName, brandImageSrc, brandCollectionUrl, false);
              followingBrandsContainer.append(newBrandElement);
              const newRemoveBtns = newBrandElement.querySelectorAll('.js-remove-brand');
              newRemoveBtns.forEach(newRemoveBtn => {
                self.removeBrand(newRemoveBtn);
              });
            } else if (followingBrandsContainerSlider) {
              const newBrandElement = self.createBrandElement(customerId, brandId, brandName, brandImageSrc, brandCollectionUrl, true);
              let container = followingBrandsContainerSlider.closest('.your-favourites-brands');
              if (container) container.classList.remove('hidden');
              Shopify.theme.jsEpicAccountProductSlider.destroySlider(document.querySelector('.js-follow-brands-container'));
              followingBrandsContainerSlider.append(newBrandElement);
              Shopify.theme.jsEpicAccountProductSlider.init(document.querySelector('.js-follow-brands-container .epic-account-product-slider'));
            }

            self.toggleBrandList();
          }).catch(error => console.error(error));
        });
      });
    },
    createBrandElement: function createBrandElement(customerId, brandId, brandName, brandImageSrc, brandCollectionUrl, sliderElement) {
      const brandItem = document.createElement('div');
      const patternElement = document.querySelector('.js-brand-pattern');
      if (!patternElement) return brandItem;

      if (sliderElement) {
        brandItem.className = 'grid__item slider__slide account-product-card js-following-brand js-brands-item';
      } else if (patternElement.classList.contains('pattern-enhanced_card')) {
        brandItem.className = 'following-brand-following-brands-item--enhanced js-brands-item js-following-brand';
      } else {
        brandItem.className = 'following-brand-following-brands-item js-brands-item js-following-brand';
      }

      brandItem.setAttribute('data-customer-id', customerId);
      brandItem.setAttribute('data-brand-id', brandId);
      brandItem.setAttribute('data-brand-name', brandName);
      brandItem.innerHTML = patternElement.innerHTML.replaceAll('[[brand_name]]', brandName);

      if (brandImageSrc && brandImageSrc != '_' && patternElement.classList.contains('pattern-enhanced_card')) {
        brandItem.innerHTML = brandItem.innerHTML.replaceAll('[[brand_image_src]]', brandImageSrc);
      } else if (brandItem.querySelector('.brands-image')) {
        brandItem.querySelector('.brands-image').innerHTML = '';
      }

      if (brandCollectionUrl && brandCollectionUrl != '_' && patternElement.classList.contains('pattern-enhanced_card')) {
        brandItem.innerHTML = brandItem.innerHTML.replaceAll('[[collection_url]]', brandCollectionUrl);

        if (brandItem.querySelector('.brands-btn-collection.not-visible')) {
          brandItem.querySelector('.brands-btn-collection.not-visible').remove();
        }
      } else if (brandItem.querySelector('.brands-btn-collection.visible')) {
        brandItem.querySelector('.brands-btn-collection.visible').remove();
      }

      return brandItem;
    },
    removeBrandInit: function removeBrandInit() {
      const removeBrandButtons = document.querySelectorAll('.js-remove-brand');
      removeBrandButtons.forEach(removeBrandButton => {
        this.removeBrand(removeBrandButton);
      });
    },
    removeBrand: function removeBrand(removeBrandButton) {
      if (!removeBrandButton) return false;
      const brandItem = removeBrandButton.closest('.js-brands-item');
      if (!brandItem) return false;
      const brandId = brandItem.getAttribute('data-brand-id');
      const customerId = brandItem.getAttribute('data-customer-id');
      if (!brandId || !customerId) return false;
      let url;

      if (Orchestra && Orchestra.epic_favorite_brands_update) {
        url = Orchestra.epic_favorite_brands_update;
      } else {
        return false;
      }

      let self = this;
      removeBrandButton.addEventListener('click', e => {
        fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            brand_id: brandId,
            customer_id: customerId,
            action: 'remove'
          })
        }).then(response => response.json()).then(json => {
          if (json.success != true) return false;
          const brandItems = document.querySelectorAll(`.js-brands-item[data-brand-id="${brandId}"]`);
          brandItems.forEach(brandElement => {
            const isFollowingBrand = brandElement.classList.contains('js-following-brand');

            if (isFollowingBrand) {
              if (brandElement.closest('.js-follow-brands-container')) {
                Shopify.theme.jsEpicAccountProductSlider.destroySlider(brandElement.closest('.js-follow-brands-container'));
              }

              brandElement.remove();

              if (document.querySelector('.js-follow-brands-container .epic-account-product-slider')) {
                Shopify.theme.jsEpicAccountProductSlider.init(document.querySelector('.js-follow-brands-container .epic-account-product-slider'));
              }
            } else {
              const removeBtn = brandElement.querySelector('.js-remove-brand');
              const addBtn = brandElement.querySelector('.js-add-brand');
              if (removeBtn) removeBtn.classList.add('hidden');
              if (addBtn) addBtn.classList.remove('hidden');
            }
          });
          self.toggleBrandList();
        }).catch(error => console.error(error));
      });
    },
    toggleBrandList: function toggleBrandList() {
      const followingBrandsItems = document.querySelectorAll('.js-following-brand');
      const followingBrandWithBrandsContainer = document.querySelector('.following-brand-wrapper-with-brands');
      const followingBrandNoBrandsContainer = document.querySelector('.following-brand-wrapper-no-brands');

      if (followingBrandsItems.length <= 0) {
        let favouritesBrandsElements = document.querySelectorAll('.js-favourites-brands-element');

        if (favouritesBrandsElements.length > 0) {
          favouritesBrandsElements.forEach(favouritesBrandsElement => {
            favouritesBrandsElement.classList.add('hidden');
          });
        }
      }

      if (!followingBrandNoBrandsContainer || !followingBrandWithBrandsContainer) return false;

      if (followingBrandsItems.length > 0) {
        followingBrandWithBrandsContainer.classList.remove('hidden');
        followingBrandNoBrandsContainer.classList.add('hidden');
      } else {
        followingBrandWithBrandsContainer.classList.add('hidden');
        followingBrandNoBrandsContainer.classList.remove('hidden');
      }
    }
  };
  Shopify.theme.jsEpicAccountBrands.init();
}

export { epicAccountBrands as default };
